import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  ContentConfigurationKeys,
  NAMESPACE_CONTENT,
} from '@epicuro-next/platform/configuration';
import {
  BROWSER_STORAGE_SERVICE,
  BROWSER_STORAGE_TOKEN,
} from '@epicuro-next/platform/storage';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

import { transformStyleTagContents } from '../../utils';

import { initialTestContent } from './initial-test-content';

const contentKey = 'playground-content';
@Component({
  selector: 'epc-content-playground',
  templateUrl: './content-playground.component.html',
  styleUrls: ['./content-playground.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ContentPlaygroundComponent implements AfterViewInit {
  public previewAreaId = 'preview-area';
  public contentStr = this.getStoredContent() ?? initialTestContent;

  private changeCommand$ = new Subject<void>();

  @ViewChild('host') public host?: ElementRef;

  public ContentConfigurationKeys = ContentConfigurationKeys;
  public NAMESPACE_CONTENT = NAMESPACE_CONTENT;

  constructor(
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    @Inject(BROWSER_STORAGE_TOKEN)
    private storageService: BROWSER_STORAGE_SERVICE,
  ) {}

  public ngAfterViewInit() {
    this.changeCommand$
      .pipe(debounceTime(1000))
      .subscribe(() => this._onChange());
    this._onChange();
  }

  public onChange() {
    this.changeCommand$.next();
  }

  private _onChange() {
    this.cdr.detectChanges(); // get update on ngModel in contentStr
    if (this.host) {
      const content = transformStyleTagContents(
        this.contentStr,
        `#${this.previewAreaId}`,
      );
      this.renderer.setProperty(this.host.nativeElement, 'innerHTML', content);
      this.storeContent();
    }
  }

  private getStoredContent() {
    return this.storageService.get(contentKey) as string | null;
  }

  private storeContent() {
    this.storageService.set(contentKey, this.contentStr);
  }
}
